import React from "react";

export default function LogoTableHead() {
  return (
    <thead>
      <tr>
        <th></th>
        <th></th>
        <th>Positiv (svart)</th>
        <th>Negativ (hvit)</th>
      </tr>
    </thead>
  );
}
